import React from 'react';

export default function Preview() {
	return (
		<div id="Preview" className="tab-pane fade">
			<a href="#">PDF Preview</a>
		</div>
	);
}
